import { TableTemplate } from "components/templates/default/table/TableTemplate";
import AddModal from "./add";
import ViewModal from "./view";
import { AddEmail, Email } from "api/interfaces/emailInterface.interface";
import { useLocation, useNavigate } from "react-router-dom";
import EmailRecipient from "./recipients/EmailRecipient";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import Status, { StatusType } from "components/blocks/status/Status";
import { ClickSearch } from "components/atoms/input/search/SearchInput";
import { TableColumnsType } from "antd";
import { CommonTable } from "components/atoms/table/AntdTable";
import { Option } from "utils/options";
import { EmailPresenterWrapper } from "./EmailStyled";
import Tabs from "components/atoms/tabs/Tabs";
import { EMAIL_PAGE_TABS } from "./EmailContainer";

export type Props = {
  isAddModal: boolean;
  isEditModal: boolean;
  isViewModal: boolean;
  onModal: (type?: string) => void;
  columns: TableColumnsType<Email>;
  data: Array<Email>;
  currentMenu: EMAIL_PAGE_TABS;
  emailMenus: Option[];
  selectedEmail: Email | undefined;
  onChangeCurrentMenu: (value: string) => void;
  onClickSendEmail: (email: AddEmail, emailId?: string) => void;
  onRowClicked: (row: Email) => void;
  onChangePage: (page: number, totalRows: number) => void;
  paginationInfo: BasePagination;
  status: StatusType;
  onClickSearch: ClickSearch;
  tablePending: boolean;
};

export function EmailPresenter({
  isAddModal,
  isEditModal,
  isViewModal,
  onModal,
  columns,
  data,
  emailMenus,
  currentMenu,
  onChangeCurrentMenu,
  onClickSendEmail,
  selectedEmail,
  onRowClicked,
  onChangePage,
  paginationInfo,
  status,
  onClickSearch,
  tablePending,
}: Props): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const isRecipient = location.pathname.includes("/recipients");

  const titleComponent = isRecipient ? (
    [
      {
        label: "Sent Emails",
        onClick: () => navigate(-1),
      },
      {
        label: selectedEmail?.subject,
      },
    ]
  ) : (
    <Tabs
      tabs={emailMenus}
      currentTab={currentMenu.toString()}
      onChangeTab={onChangeCurrentMenu}
    />
  );

  return (
    <EmailPresenterWrapper>
      {!isRecipient ? (
        <TableTemplate
          onClickBtn={() => onModal("add")}
          buttonLabel="New Email"
          onClickSearch={onClickSearch}
          keyword={paginationInfo.keyword}
          titleComponent={titleComponent}
          centerChildren={<Status status={status} />}
          data-testid="manager-email-email-table-template-modal"
        >
          <CommonTable
            columns={columns}
            dataSource={data}
            queryInfo={paginationInfo}
            onChangePage={onChangePage}
            loading={tablePending}
          />
        </TableTemplate>
      ) : (
        <EmailRecipient titleComponent={titleComponent} />
      )}

      {isAddModal && (
        <AddModal
          onModal={() => onModal("add")}
          onClickSendEmail={onClickSendEmail}
        />
      )}

      {isEditModal && selectedEmail !== undefined && (
        <AddModal
          isEdit
          onModal={() => onModal("edit")}
          onClickSendEmail={onClickSendEmail}
          selectedEmail={selectedEmail}
        />
      )}

      {isViewModal && selectedEmail !== undefined && (
        <ViewModal
          onModal={() => onModal("view")}
          selectedEmail={selectedEmail}
        />
      )}
    </EmailPresenterWrapper>
  );
}
